import {useQuery} from "@tanstack/react-query"
import {userService} from "services"
import {Auth} from "types/auth"

type UserProps = {
    userId?: number
    linkedObjects?: boolean
}

export const useUser = ({userId, linkedObjects = false}: UserProps) => {
    const query = useQuery<Auth.UserProfile>(
        ["user", userId, linkedObjects],
        async () => {
            const user = await userService.getUserById({filter: {id: [userId]}, linkedObjects})
            return user
        },
        {
            enabled: !!userId,
            refetchOnMount: false
        }
    )

    return {
        user: query.data,
        isLoading: query.isFetching
    }
}
